module.exports = __webpack_public_path__ + "static/media/party-catering-3.30634251.jpg";